export class GslError extends Error {
    constructor(message, cause) {
        super(message);
        this.name = "GslError";
        Object.setPrototypeOf(this, new.target.prototype);
        if (typeof cause !== "string")
            this.cause = cause;
    }
}
/**
 * This is usually thrown if you provide invalid coordinates.
 * Make sure your report is in the contiguous United States
 * if from rucsoundings.noaa.gov
 */
export class CoordinatesGslError extends GslError {
    constructor() {
        super("Invalid GSL file (suspect invalid lat/lon coordinates)");
        this.name = "CoordinatesGslError";
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
